/* eslint-disable react/prop-types */
import { Grid, Box } from '@mui/material';
import { TopHeaderBar } from './top_header_bar.component';
import { MianNavBarLeft } from './main_navBar_left.component';
import { useNavigate } from 'react-router-dom';
const DashboardLayout = ({
  children,
  padding = false,
  handleReset,
  handleDrawerClose,
  state,
  list,
  // Additional props for filter functionality
  totalAlarms,
  value,
  setValue,
  toggleDrawer,
  applyFilters,
  selectedTab,
  regions,
  cities,
  rings,
  sites,
  links,
  region,
  setRegion,
  city,
  setCity,
  ring,
  setRing,
  site,
  setSite,
  link,
  setLink,
  handleRegionChange,
  handleCityChange,
  handleSiteChange,
  handleLinkChange,
  handleApply,
  setFiltersValue,
}) => {
  const navigate = useNavigate();
  const handleTabSelection = (tabValue) => {
    if (setValue) {
      setValue(tabValue);
    }
    sessionStorage.setItem('selectedTab', tabValue);
    if (handleDrawerClose) {
      handleDrawerClose();
    }
    if (handleReset) {
      handleReset();
    }
    navigate('/fibers');
  };
  return (
    <Box sx={{ height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      <Box>
        <TopHeaderBar
          state={state}
          list={list}
          totalAlarms={totalAlarms}
          value={value}
          setValue={setValue}
          toggleDrawer={toggleDrawer}
          applyFilters={applyFilters}
          selectedTab={selectedTab}
          regions={regions}
          cities={cities}
          rings={rings}
          sites={sites}
          links={links}
          region={region}
          setRegion={setRegion}
          city={city}
          setCity={setCity}
          ring={ring}
          setRing={setRing}
          site={site}
          setSite={setSite}
          link={link}
          setLink={setLink}
          handleRegionChange={handleRegionChange}
          handleCityChange={handleCityChange}
          handleSiteChange={handleSiteChange}
          handleLinkChange={handleLinkChange}
          handleReset={handleReset}
          handleApply={handleApply}
        />
      </Box>
      <Grid container sx={{ flexGrow: 1, overflow: 'hidden' }}>
        <Grid
          item
          sm={0.5}
          xs={2}
          borderRight={'1px solid #ccc'}
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            overflowY: 'auto', // if needed
          }}
        >
          <MianNavBarLeft
            handleTabSelection={handleTabSelection}
            handleDrawerClose={handleDrawerClose}
            handleReset={handleReset}
            setFiltersValue={setFiltersValue}
          />
        </Grid>

        <Grid
          item
          xs={10}
          sm={11.5}
          className="tabset"
          sx={{
            // paddingLeft: 4,
            paddingTop: padding ? 2 : 0,
            height: '100%',
            overflowY: 'auto',
          }}
        >
          {children}
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardLayout;
